module.exports = __webpack_public_path__ + "img/tn.03ddda06.svg";